import { render, staticRenderFns } from "./ConfigSection.vue?vue&type=template&id=4b4c1ae2&"
import script from "./ConfigSection.vue?vue&type=script&lang=js&"
export * from "./ConfigSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports